import { ApiUrls } from '@/enums';
import useRoom from '@/compositions/useRoom';
import { ref } from '@vue/composition-api';
import useSocket from '@/compositions/useSocket';
import api from '../../api';

const messages = ref([]);
const showChat = ref(false);
const register = ref(false);

export default function useChat() {
  const { room, auth, candidate } = useRoom();
  const { registerMessage, sendEvent } = useSocket();

  if (!register.value) {
    registerMessage('chat:message', ({ message, publisher }) => {
      messages.value.push({ message, publisher });
    });
    register.value = true;
  }

  async function fetch() {
    messages.value = (await api.post(`${ApiUrls.V1}/chat/${room.value}`, {
      room: room.value,
      secret: auth.value?.secret || candidate.value?.secret,
    })).data;
  }

  async function addMessage(message) {
    sendEvent('action:chat-message', { room: room.value, message });
  }

  return {
    fetch,
    addMessage,
    messages,
    showChat,
  };
}
